// What admin's Referrals reads (decision 55, migration 79; docs/data-model.md 10.7), each as the staff member
// through src/admin/api.js: owner and admin at 2-step login read everything here, and anyone else is given
// nothing by the database.
// - The ledger: hub.staff_introductions, every line at once (at most 2,000), filtered on the page, so Needs a
//   look's count and Owed right now always count every line; and the refund cards beside it (below).
// - The offers: hub.referral_offers, every product's, beside the catalogue the shell already holds.
// - Who can refer: hub.referral_candidates for 1 product, and that product's intakes (hub.cohorts).
// - The person page's card: their codes and ticks, straight from the tables, and their lines (as referrer
//   or referred) from hub.staff_introductions.
import { byBoardOrder } from '../people/words.js'

export const LEDGER_LIMIT = 2000
export const COHORT_COLUMNS = 'id, product_id, name, kind, starts_on, sort_order'

// The refunds (the review of 18 Oct): a full refund or a dispute leaves its line as it was and raises a Today card
// (hub.flags, kind introduction, reason refunded, owner and admin only), so the ledger reads those cards beside the
// lines, open or done, and each line a refund touched carries refunded_at, the first card's day: Introductions,
// Owed right now and the Mark paid box then say Refunded, so nobody pays a refunded sale without seeing it.
export const REFUND_COLUMNS = 'detail, raised_at'
export function loadRefunds(api) {
  return api.run(api.from('flags').select(REFUND_COLUMNS).eq('kind', 'introduction').eq('detail->>reason', 'refunded').order('raised_at'))
}
export function withRefunds(lines = [], refunds = []) {
  const at = new Map()
  for (const r of refunds || []) {
    const id = r?.detail?.introduction_id
    if (!id || !r.raised_at) continue
    if (!at.has(id) || Date.parse(r.raised_at) < Date.parse(at.get(id))) at.set(id, r.raised_at)
  }
  return (lines || []).map(l => (at.has(l.id) ? { ...l, refunded_at: at.get(l.id) } : l))
}
export async function loadLedger(api) {
  const [lines, refunds] = await Promise.all([api.staff_introductions({ limit: LEDGER_LIMIT }), loadRefunds(api)])
  return withRefunds(lines, refunds)
}
export const loadOffers = api => api.referral_offers()
export const loadCandidates = (api, productId) => api.referral_candidates({ product: productId })
export function loadIntakes(api, productId) {
  return api.run(api.from('cohorts').select(COHORT_COLUMNS).eq('product_id', productId).order('sort_order'))
}

export async function loadPersonReferrals(api, personId) {
  const [codes, ticks, lines, offers] = await Promise.all([
    api.referral_codes(personId),
    api.referral_ticks(personId),
    api.staff_introductions({ person: personId, limit: 50 }),
    api.referral_offers(),
  ])
  return { codes: codes || [], ticks: ticks || [], lines: lines || [], offers: offers || [] }
}

// The paid products that can have an offer (not the 1-2-1 client space), in the boards' order
export const offerProducts = (products = []) => byBoardOrder(products.filter(p => p.access_kind === 'paid' && p.type !== 'client_space'))

// The products with an offer, in the boards' order, each with its offer
export function productsWithOffers(products = [], offers = []) {
  const by = new Map(offers.map(o => [o.product_id, o]))
  return offerProducts(products).filter(p => by.has(p.id)).map(p => ({ ...p, offer: by.get(p.id) }))
}
